<template>

	<div id="loginWrapper" v-if="isLoaded">

		<div class="topBar"></div>
		<div class="logo"></div>

		<div class="loginContainer" :class="{ isError: isError }">

			<!-- LOGIN SCREEN -->
			<template v-if="isScreen == 'login'">

				<h1>{{ labels['LOGIN-TITLE-LOGIN'] }}</h1>

				<template v-if="isError">
					<p class="errorMsg"> {{ errorMsg }} </p>
				</template>

				<div v-if="isLoggedOut" class="logout-notice">
					<i class="fa fa-sign-out"></i>
					Sie wurden abgemeldet. Bitte melden Sie sich erneut an.
				</div>

				<form role="form" @submit.prevent="submitLogin">

					<div class="field">
						<div class="control has-icon">
							<input class="input is-medium" :placeholder="labels['LOGIN-PLACEHOLDER-USERNAME']"
								key="username-input" v-model="credentials.username" autocorrect="off" autofocus>
							<i class="fa icon-ak-user"></i>
						</div>
					</div>

					<div class="field">
						<div class="control has-icon">
							<input class="input is-medium" type="password"
								:placeholder="labels['LOGIN-PLACEHOLDER-PASSWORD']" v-model="credentials.password"
								autocorrect="off">
							<i class="fa fa-lock"></i>
						</div>
					</div>
					<div class="field">
						<div class="control">
							<span class="passForgot" @click="screenRequestPassword">Passwort vergessen?</span>
							<button type="submit" class="button is-normal is-dark is-pulled-right"
								:class="{ 'is-loading': isLoading }">{{ labels['LOGIN-BTN-LOGIN'] }}</button>
						</div>
					</div>

				</form>

			</template>


			<!-- REQUEST NEW PASS SCREEN -->
			<template v-else-if="isScreen == 'requestPass'">

				<h1>{{ labels['LOGIN-TITLE-RESET_PASSWORD'] }}</h1>

				<p class="infoText">{{ labels['LOGIN-MSG-PLEASE_ENTER_USERNAME'] }}</p>

				<template v-if="isError">
					<p class="errorMsg"> {{ errorMsg }} </p>
				</template>

				<form role="form" @submit.prevent="submitRequestPassword">

					<div class="field">
						<div class="control has-icon">
							<input class="input is-medium" type="text"
								:placeholder="labels['LOGIN-PLACEHOLDER-USERNAME']" key="username-input"
								v-model="credentials.username" autocorrect="off" required>
							<i class="fa fa-user"></i>
						</div>
					</div>

					<div class="field">
						<div class="control">
							<span class="cancel" @click="screenLogin">abbrechen</span>
							<button type="submit" class="button is-normal is-dark is-pulled-right"
								:class="{ 'is-loading': isLoading }">{{ labels['LOGIN-BTN-RESET_PASSWORD']
								}}</button>
						</div>
					</div>

				</form>

			</template>


			<!-- REQUEST NEW PASS SCREEN OK -->
			<template v-else-if="isScreen == 'requestPassOk'">

				<h1>{{ labels['LOGIN-TITLE-RESET_PASSWORD'] }}</h1>

				<alert type="info"><span v-html="passwordResetMsg"></span></alert>

			</template>

		</div>



	</div> <!-- // #loginWrapper -->


</template>



<script>
import auth from '../auth'

export default {

	name: 'login',

	data() {
		return {
			labels: null,
			isLoaded: false,
			siteType: '',
			credentials: {
				username: '',
				password: ''
			},
			isScreen: 'login',
			errorMsg: null,
			passwordResetMsg: false,
			isError: false,
			isLoading: false,
			isLoggedOut: false,
			user: {},
		}
	},

	created() {

		// Check for a one-time logout notification flag set by auth.logout().
		// Read and immediately clear it so it only shows once.
		if (sessionStorage.getItem('showLoggedOutNotice') === '1') {
			this.isLoggedOut = true;
			sessionStorage.removeItem('showLoggedOutNotice');
		}

		this.fetchLabels();

	},


	mounted() {

	},

	methods: {

		submitLogin() {

			this.isLoading = true;
			this.isError = false;

			auth.login(this, this.credentials, this.$route.query.redirect || '/');

		},

		submitRequestPassword() {

			this.isLoading = true;
			this.isError = false;

			const loginAxios = this.axios.create();

			loginAxios
				.get(this.$config.api + 'user/generateToken?username=' + this.credentials.username + '&include=user.person')
				.then((response) => {
					this.isLoading = false;
					this.screenRequestPasswordSuccess();
				})
				.catch((err) => {
					this.isLoading = false;
					this.isError = true;
					this.errorMsg = err.response.data.title;
				})

		},

		screenLogin() {
			this.title = this.labels['LOGIN-TITLE-LOGIN'];
			this.isScreen = 'login';
			this.isError = false;
			this.isLoading = false;
		},

		screenRequestPassword() {
			this.title = this.labels['LOGIN-TITLE-RESET_PASSWORD'];
			this.isScreen = 'requestPass';
			this.isError = false;
			this.isLoading = false;
		},

		screenRequestPasswordSuccess() {
			this.isScreen = 'requestPassOk';
			this.isError = false;
			this.isLoading = false;
			this.passwordResetMsg = this.labels['LOGIN-MSG-PASSWORD_REQUEST_SUCCESS'];
		},

		screenVerifyToken() {
			this.title = this.labels['LOGIN-TITLE-VERIFY_TOKEN'];
			this.isScreen = 'verifyToken';
			this.isError = false;
			this.isLoading = false;
		},

		getMessage() {

			// check if there are redirect messages from the router
			if (this.$route.query.err) {

				// permissions problem
				if (this.$route.query.err == 1) {
					this.isError = true;
					this.errorMsg = 'You do not own permissions to enter this site.';
				}

				// not logged in
			} else if (this.$route.query.redirect) {
				this.isError = true;
				this.errorMsg = 'You need to login first';
			}
		},

		fetchLabels() {

			this.axios
				.get(this.$config.api + 'label/keyValueList?language=de&app=cms')
				.then((response) => {
					this.labels = response.data;
					this.isLoaded = true;
				})
				.catch((err) => {

				});

		}

	},

}
</script>


<style scoped>

.isDevOrStageEnv #loginWrapper {
	top: 32px;
}

#loginWrapper {
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	height: auto;
}

#loginWrapper .logo {
	position: absolute;
	z-index: 999;
	width: 150px;
	height: 50px;
	left: 20px;
	right: 0;
	top: 30px;
	margin: 0;
	background: transparent url('/static/img/hc-logo.png') no-repeat 0 0 !important;
	background-size: contain !important;
}

#loginWrapper .topBar {
	position: absolute;
	z-index: 999;
	top: 0;
	left: 0;
	right: 0;
	width: auto;
	height: 8px;
	/* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#cade74+0,87cbf0+100 */
	background: #cade74;
	/* Old browsers */
	background: -moz-linear-gradient(left, #cade74 0%, #87cbf0 100%);
	/* FF3.6-15 */
	background: -webkit-linear-gradient(left, #cade74 0%, #87cbf0 100%);
	/* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to right, #cade74 0%, #87cbf0 100%);
	/* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#cade74', endColorstr='#87cbf0', GradientType=1);
	/* IE6-9 */
}

#loginWrapper .loginContainer {
	background: rgba(255, 255, 255, 0.6);
	position: absolute;
	top: 50%;
	left: 50%;
	margin-right: -50%;
	transform: translate(-50%, -50%);
	min-width: 420px;
	max-width: 50vmin;
	box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
	padding: 25px;
}

#loginWrapper .loginContainer .infoText {
	font-size: 1rem;
	margin: 0 0 10px 0;
}

#loginWrapper .isError {
	animation: shake .6s ease-out;
}

#loginWrapper h1 {
	font-size: 20px;
	text-transform: uppercase;
	margin: 0 0 10px 0;
}

#loginWrapper .errorMsg {
	color: red;
	margin: 0 0 15px 0;
	font-size: 0.85rem;
}

#loginWrapper .field {
	margin: 0 0 10px 0;
}

#loginWrapper .passForgot,
#loginWrapper .cancel {
	display: inline-block;
	margin: 6px 0 0 5px;
	cursor: pointer;
}

#loginWrapper .passForgot:hover,
#loginWrapper .cancel:hover {
	text-decoration: underline;
}

#loginWrapper .logout-notice {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 15px;
	padding: 10px 14px;
	border-left: 3px solid rgb(243, 156, 18);
	background-color: rgba(243, 156, 18, 0.1);
	color: #555;
	font-size: 0.875rem;
	border-radius: 2px;
}

#loginWrapper .logout-notice .fa {
	color: rgb(243, 156, 18);
	flex-shrink: 0;
}

#loginWrapper input:-webkit-autofill {
	-webkit-box-shadow: 0 0 0 30px white inset;
}
</style>
